let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b2VvZ")).then(() => parcelRequire('cvdTV'));